export const Jobs = {
    // Представитель компании или агентства
    COMPANY: 1,
    // Фрилансер или работаю на себя
    FREELANCE: 2,
    // Ученик
    STUDENT: 3,
    // Другое
    OTHER: 4,
}
